import styled from 'styled-components';
const HorizontalPerformanceWrapper = styled.div`    
    .round-widget-button {
        border: 0;
        width: 54px;
        height: 54px;
        border-radius: 50%;
        outline: 0;
    }

    .view-all {
        span {
            font-family: "sf-semi-bold";
            font-size: 16px;
        }
    }
`;

export default HorizontalPerformanceWrapper